import { PageRouteConfig } from '@/modules/core/app/helpers/PageRouteConfig';
import { Module } from '@/modules/core/app/constants/app.constants';
import {
  BudgetPacingRoute,
  BudgetPacingPathName,
} from '@/modules/ta/budgetpacing/budgetpacing.constants';

export const router = PageRouteConfig.factory(
  [
    {
      path: `/${BudgetPacingRoute.BUDGETPACINGS}`,
      name: BudgetPacingPathName.BUDGETPACINGS,
      component: () =>
        import(/* webpackChunkName: "budget-pacings-page" */ './pages/BudgetPacingsPage.vue'),
    },
    {
      path: `/${BudgetPacingRoute.BUDGETPACINGS}/new`,
      name: BudgetPacingPathName.BUDGETPACINGFORM_NEW,
      component: () =>
        import(
          /* webpackChunkName: "budget-pacing-form-page" */ './pages/BudgetPacingFormPage.vue'
        ),
      props: true,
    },
    {
      path: `/${BudgetPacingRoute.BUDGETPACINGS}/:id`,
      name: BudgetPacingPathName.BUDGETPACINGSDETAILPAGE,
      component: () =>
        import(
          /* webpackChunkName: "budget-pacings-details-page" */ './pages/BudgetPacingsDetailsPage.vue'
        ),
    },
  ],
  Module.BUDGETPACING
);
